const counterEmailFilter = (users, containsEmail = 0) => {
    const template = "m.counter-intel.com";
    if (containsEmail === 1) {
        return users.filter(value => !value.email.includes(template));
    } else if (containsEmail === 2) {
        return users.filter(value => value.email.includes(template));
    }
    return users;
};

export default counterEmailFilter;
